import axios from "axios";
import { supabase } from "@/lib/supabaseClient";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const LOCAL_BRAIN_UI = process.env.REACT_APP_BRAIN_LOCAL_RUNNER_UI === "true";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

/**
 * Every request pulls the latest access token from the active Supabase session
 * so refreshed sessions work automatically. No token is copy-persisted locally.
 */
api.interceptors.request.use(async (config) => {
  try {
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch { /* no session — request goes anonymous, backend will 401 if protected */ }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    // On 401, sign out so the app re-prompts login instead of using a dead token.
    if (err?.response?.status === 401 && !LOCAL_BRAIN_UI) {
      try { await supabase.auth.signOut(); } catch { /* noop */ }
    }
    return Promise.reject(err);
  }
);
